import React, { useEffect, useState } from 'react';

import { Dialog, ThemeProvider, Backdrop } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { theme } from './components/Theme';

import Calculator from './components/Calculator';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4
};
function App() {
	const [open, setOpen] = useState(false);
	const [isBraPage, setIsBraPage] = useState(true);
	const handleOpen = () => {
		setOpen(true);
	};

	useEffect(() => {
		const pageUrl = window.location.pathname;

		if (pageUrl === '/pages/bra-fitter') {
			setIsBraPage(true);
		}
	}, []);

	const handleClose = () => setOpen(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	// if (!isModal) {
	// 	return (
	// 		<ThemeProvider theme={theme}>
	// 			<div className="App">
	// 				<Calculator />
	// 			</div>
	// 		</ThemeProvider>
	// 	);
	// }

	return (
		<ThemeProvider theme={theme}>
			<div className="App">
				<div
					className={isBraPage ? 'page-pill' : 'size-pill'}
					onClick={handleOpen}
				>
					{ window.bra_calc_str.cta }
				</div>
				<Backdrop
					sx={{
						color: '#fff',
						zIndex: (theme) => theme.zIndex.drawer + 1
					}}
					open={open}
				>
					<div>
						<Dialog
							onClose={handleClose}
							open={open}
							fullScreen={fullScreen}
						>
							<Calculator onClose={handleClose} />
						</Dialog>
					</div>
				</Backdrop>
			</div>
		</ThemeProvider>
	);
}

export default App;
